/**
 * 资源管理模块路由
 * 路径前缀: /desktopCenter/resourceManage/
 */
import type { RouteRecordRaw } from "vue-router";

export const resourceManageRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/resourceManage/imageWarehouse",
		name: "ImageWarehouse",
		meta: {
			title: "图片仓库",
			keepAlive: false,
		},
		redirect: "/desktopCenter/resourceManage/imageWarehouse/materialManage",
		children: [
			{
				path: "/desktopCenter/resourceManage/imageWarehouse/materialManage",
				name: "ImageMaterialManage",
				meta: {
					title: "素材管理",
					keepAlive: false,
					iframeUrl: "cos.php/general/attachment",
				},
				component: () =>
					import(
						"@main/views/Apps/ResourceManage/ImageWarehouse/MaterialManage/MaterialManage.vue"
					),
			},
			{
				path: "/desktopCenter/resourceManage/imageWarehouse/categorySettings",
				name: "ImageCategorySettings",
				meta: {
					title: "分类设置",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/ResourceManage/ImageWarehouse/CategorySettings/CategorySettings.vue"
					),
			},
		],
	},
	{
		path: "/desktopCenter/resourceManage/audioVideoMaterial",
		name: "AudioVideoMaterial",
		meta: {
			title: "音视频素材",
			keepAlive: false,
		},
		redirect: "/desktopCenter/resourceManage/audioVideoMaterial/materialManage",
		children: [
			{
				path: "/desktopCenter/resourceManage/audioVideoMaterial/materialManage",
				name: "AVMaterialManage",
				meta: {
					title: "素材管理",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/ResourceManage/AudioVideoMaterial/MaterialManage/MaterialManage.vue"
					),
			},
			{
				path: "/desktopCenter/resourceManage/audioVideoMaterial/categorySettings",
				name: "AVCategorySettings",
				meta: {
					title: "分类设置",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/ResourceManage/AudioVideoMaterial/CategorySettings/CategorySettings.vue"
					),
			},
		],
	},
];
